var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 297,
    viewBox: "0 0 297 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.027 33.775H192.463V29.052C192.462 13.032 179.429 0 163.409 0H133.589C117.569 0 104.537 13.032 104.537 29.052V33.775H68.973C51.377 33.775 37.061 48.091 37.061 65.687V84.345C37.061 89.991 41.639 94.569 47.285 94.569H54.747L68.641 261.3C70.309 281.319 87.352 297 107.44 297H189.559C209.647 297 226.69 281.319 228.358 261.3L242.252 94.57H249.714C255.36 94.57 259.938 89.992 259.938 84.346V65.688C259.939 48.092 245.623 33.775 228.027 33.775ZM124.985 29.052C124.985 24.308 128.845 20.448 133.589 20.448H163.409C168.154 20.448 172.014 24.308 172.014 29.052V33.775H124.985V29.052V29.052ZM207.981 259.602C207.189 269.107 199.097 276.552 189.559 276.552H107.44C97.902 276.552 89.81 269.107 89.018 259.602L75.265 94.57H221.734L207.981 259.602ZM239.492 74.123H57.509V65.688C57.509 59.366 62.652 54.223 68.974 54.223H228.027C234.349 54.223 239.492 59.366 239.492 65.688V74.123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico_delete.3ab8115f20500b341b1e2a516c9b4f33.svg";
export { ForwardRef as ReactComponent };